import Typo from "@/src/components/atom/Typo";
import DATE_FORMAT_STRINGS from "@/src/constant/dateFormat";
import { getFormattedTimezoneDateWithOffset } from "@/src/hooks/useCompanyLocalDate";
import { CELL_TYPE_UNDER_LINE_LINK_ACTION } from "@/src/utils/row-data-util";
import { ColDef, ValueGetterParams } from "ag-grid-community";
import { getAmountOfPayment } from "../../SubscriptionManagement/utils/getPayments";
import renderCreditPaymentStatusBadge from "../utils/renderCreditPaymentStatusBadge";

export const purchaseRefundColumns = [
  {
    headerClass: "ag-right-aligned-cell ag-header-hide",
    cellStyle: { textAlign: "center" },
    field: "paymentNo",
    flex: 1,
    minWidth: 190,
    cellRenderer: CELL_TYPE_UNDER_LINE_LINK_ACTION,
    sortable: false,
  },
  {
    headerClass: "ag-right-aligned-cell ag-header-hide",
    cellStyle: { textAlign: "center" },
    field: "purchaseCredit",
    flex: 1,
    minWidth: 150,
    cellRenderer: (params: ValueGetterParams) => {
      const credit = parseInt(params.data.paymentDetail.replace(/[^0-9]/g, ""));

      return credit ? <>{credit.toLocaleString("ko-KR")}</> : "-";
    },
    sortable: false,
  },
  {
    headerClass: "ag-right-aligned-cell ag-header-hide",
    cellStyle: { textAlign: "center" },
    field: "paymentAmount",
    flex: 1,
    minWidth: 150,
    cellRenderer: (params: ValueGetterParams) => {
      const price = getAmountOfPayment({
        exchangeRate: Number(params.data.exchangeRate),
        price: Number(params.data.price),
        currencyUnit: params.data.currencyUnit,
      });

      return (
        <Typo typoType="b9r">
          {price.toLocaleString("ko-KR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}{" "}
          {params.data.currencyUnit}
        </Typo>
      );
    },
    sortable: false,
  },
  {
    headerClass: "ag-right-aligned-cell ag-header-hide",
    cellStyle: { textAlign: "center" },
    field: "createdAt",
    flex: 1,
    minWidth: 150,
    cellRenderer: (params: ValueGetterParams) => {
      const gmtOffset = params.data?.gmtOffset;

      return params.data.createdAt ? (
        <Typo typoType="b9r">
          {getFormattedTimezoneDateWithOffset({
            date: params.data.createdAt,
            gmtOffset,
            format: DATE_FORMAT_STRINGS.YYYY_MM_DD_HH_mm,
          })}
        </Typo>
      ) : (
        "-"
      );
    },
    sortable: true,
  },
  {
    headerClass: "ag-right-aligned-cell ag-header-hide",
    cellStyle: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    field: "status",
    flex: 1,
    minWidth: 150,
    cellRenderer: (params: ValueGetterParams) => {
      const t = params.data.t;

      return params.data.paymentStatus ? (
        <Typo typoType="b9r">
          {renderCreditPaymentStatusBadge({
            type: params.data.paymentStatus,
            t,
          })}
        </Typo>
      ) : (
        "-"
      );
    },
    sortable: false,
  },
  {
    headerClass: "ag-right-aligned-cell ag-header-hide",
    cellStyle: { textAlign: "center" },
    field: "management",
    flex: 1,
    minWidth: 150,
    cellRenderer: () => {
      return "-";
    },
    sortable: false,
  },
] as ColDef[];
